var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconMenuHamburger(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 18C4 17.4477 4.47756 17 5.06667 17H18.9333C19.5224 17 20 17.4477 20 18C20 18.5523 19.5224 19 18.9333 19H5.06667C4.47756 19 4 18.5523 4 18Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 11.4477 4.47756 11 5.06667 11H18.9333C19.5224 11 20 11.4477 20 12C20 12.5523 19.5224 13 18.9333 13H5.06667C4.47756 13 4 12.5523 4 12Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6C4 5.44772 4.47756 5 5.06667 5H18.9333C19.5224 5 20 5.44772 20 6C20 6.55228 19.5224 7 18.9333 7H5.06667C4.47756 7 4 6.55228 4 6Z", fill: color })));
}
//# sourceMappingURL=icon.menu-hamburger.component.js.map